export function distance(p1, p2) {
	// Eventually we may implement better distance algorithms and make one of them the default, but for now....
	return flattenedEuclideanDistance(p1, p2);
}

export function euclideanDistance(p1, p2) {
	return Math.pow(euclideanDistanceSq(p1, p2), 0.5);
}

export function euclideanDistanceSq(p1, p2) {
	const xy1 = toXY(p1);
	const xy2 = toXY(p2);

	return Math.pow(xy1.x - xy2.x, 2) + Math.pow(xy1.y - xy2.y, 2);
}

export function flattenedEuclideanDistance(p1, p2) {
	return Math.pow(flattenedEuclideanDistanceSq(p1, p2), 0.5);
}

export function flattenedEuclideanDistanceSq(p1, p2) {
	const xy1 = toXY(p1);
	const xy2 = toXY(p2);
	const latCos = Math.cos(xy1.x);
	return Math.pow(latCos * (xy1.x - xy2.x), 2) + Math.pow(xy1.y - xy2.y, 2);
}

export function manhattanDistance(p1, p2) {
	const xy1 = toXY(p1);
	const xy2 = toXY(p2);

	return Math.abs(xy1.x - xy2.x) + Math.abs(xy1.y - xy2.y);
}

export function toXY(p) {
	const x = parseFloat(p.x || p.lat || p.latitude || p[0], 10);
	const y = parseFloat(p.y || p.lng || p.lon || p.longitude || p[1], 10);
	return { x, y };
}
